import { type UseUserSubscriptionReturnType } from './useUserSubscription.types';
import { useUserEntitlementsContext } from '../../context';
import { UserEntitlementsContextType } from '../../context/userEntitlementsContext.types';
import { useIsOgClinicUser } from '../useIsOgClinicUser';

export const useUserSubscription = ():
  | UserEntitlementsContextType
  | UseUserSubscriptionReturnType => {
  const entitlementsResult = useUserEntitlementsContext();
  const isOgClinicUser = useIsOgClinicUser();

  if (isOgClinicUser) {
    return {
      ...entitlementsResult,
      isUpgradeButtonVisible: false,
    };
  }

  return entitlementsResult;
};
